const features = [
  {
    icon: 'ri-movie-2-line',
    title: '电视剧全集收录',
    desc: '专注收录电视剧全集与连续剧完整版，覆盖国产剧、韩剧、美剧、日剧等热门类型，超过2000部电视剧在线全集免费看，大结局第一时间上线。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清流畅播放',
    desc: '所有电视剧全集均支持高清画质在线播放，多线路智能切换确保播放不缓冲。无论是手机还是电脑，都能享受流畅稳定的追剧体验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '免费无需注册',
    desc: '萝卜影视坚持免费开放所有电视剧在线全集资源，无需注册登录即可直接观看。无隐藏收费、无强制广告，纯净追剧环境让体验更舒适。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">
              平台优势
            </h2>
            <p className="text-foreground-400 text-sm max-w-[500px] mx-auto">
              为什么选择萝卜影视观看电视剧全集与连续剧完整版
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {features.map((feature, i) => (
              <div
                key={i}
                className="bg-background-100 rounded-xl p-6 md:p-7 border border-background-300/30 hover:border-primary-500/25 transition-colors duration-200 text-center"
              >
                <div className="w-14 h-14 rounded-xl bg-primary-500/15 flex items-center justify-center mx-auto mb-5">
                  <i className={`${feature.icon} text-primary-400 text-2xl`}></i>
                </div>
                <h3 className="font-heading text-foreground-100 text-lg mb-3">
                  {feature.title}
                </h3>
                <p className="text-foreground-400 text-sm leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}